module.exports = __webpack_public_path__ + "static/media/finished_gray.ef541597.svg";